export const centTo$ = (param) => {
  let num = Number(param);
  if (num === 'NaN') {
    return 0;
  }
  num /= 100;
  if (num % 1 === 0) {
    return num;
  }
  return num.toFixed(2);
};



// WEBPACK FOOTER //
// ./src/misc/formatMoney.js